export const TypesAplicativo = {
    SET_AGRUPADOR: "aplicativo/SET_AGRUPADOR",
}

export const INITIAL = {
    agrupador: {Id: 1}
}

export const AplicativoReducerActions =
{
    setAgrupador
}

export default function aplicativoReducer(state = INITIAL, action) {
    switch (action.type) {
        case TypesAplicativo.SET_AGRUPADOR:
            return {
                ...state,
                agrupador: action.payload
            }
        default:
            return state;
        }
    }

function setAgrupador(agrupador)
{
    return {
        type: TypesAplicativo.SET_AGRUPADOR,
        payload: agrupador
    }
}